import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import styled from 'styled-components';
import { useHistory } from 'react-router-dom';

import { selectMaintenance } from '../App/slice/selectors';
import ContainerFluid from 'app/components/Layout/ContainerFluid';
import { MAINTENANCE } from '../App/slice';
import { useGlobalFunction } from '../App/hooks/useGlobalFunction';

const MaintenancePage: React.FC = () => {
  const { data: maintenanceData } = useSelector(selectMaintenance);
  const dispatch = useDispatch();
  const history = useHistory();
  const { onCloseDialogAuth } = useGlobalFunction();

  useEffect(() => {
    if (!maintenanceData?.isMaintain) history.push('/');
  }, [history, maintenanceData?.isMaintain]);

  useEffect(() => {
    const checkMaintenance = async (location, unblock) => {
      const onSuccess = data => {
        if (!data?.isMaintain) {
          history.push(location.pathname);
          unblock();
        }
      };
      dispatch(MAINTENANCE({ onSuccess }));
    };

    const unblockNavigate = history.block(location => {
      if (location.pathname !== '/maintenance')
        checkMaintenance(location, unblockNavigate);
      return false;
    });

    return () => {
      unblockNavigate();
    };
  }, [dispatch, history]);

  useEffect(() => {
    onCloseDialogAuth();
  }, [onCloseDialogAuth]);

  return (
    <ContainerFluid>
      <Container
        dangerouslySetInnerHTML={{
          __html: maintenanceData?.page_maintain?.pageinfo ?? '',
        }}
        style={{
          maxWidth: 856,
          margin: 'auto',
          background: '#ffffff',
          borderRadius: 20,
          padding: '48px 32px',
          fontSize: 14,
        }}
      />
    </ContainerFluid>
  );
};

export default MaintenancePage;

const Container = styled.div`
  .title {
    span {
      line-height: 28px;
    }
  }
`;
